export default "/build/static/fonts/Whitney-BoldItal_Web.woff2";